'use client';

import { useParams } from 'next/navigation';

import Cookies from 'js-cookie';

import { useAuth } from '@shared/common/providers/AuthProvider';

import {
  useLaunchpadProjectWithSalesPrefetchQuery,
  useLaunchpadProjectWithSalesQuery,
} from '@query/launchpadProjects';

import { getProjectContent } from '@launchpad/data/projects';

import PoolCard from './ui/OptionsCard/PoolCard';
import { ProjectContent } from './ui/ProjectContent';
import ProjectInfo, { ProjectInfoSkeleton } from './ui/ProjectInfo/ProjectInfo';

const Page = () => {
  const { id } = useParams<{ id: string }>();
  const { isAuth, isLoading: isUserLoading } = useAuth();
  const isHasAuthCookies = Boolean(Cookies.get('Authorized'));
  const { data: prefetchedProject } = useLaunchpadProjectWithSalesPrefetchQuery(id);
  const { data: project, isPending: isLoading } = useLaunchpadProjectWithSalesQuery(
    id,
    isUserLoading ? isHasAuthCookies : isAuth,
  );
  const content = getProjectContent(id.toLowerCase());

  const isMultiPool = project?.salePool && project?.salePool?.length > 1;
  const isMultiPoolPrefetched = (prefetchedProject?.salePool?.length || 0) > 1;
  const isHaveSale = (prefetchedProject?.salePool?.length || 0) > 0;

  const showProjectInfoSkeleton = isLoading || !project;
  const showPoolsSkeleton = isMultiPoolPrefetched && isLoading;
  const showPools = isMultiPool && !isLoading;

  return (
    <main className="py-16">
      <section className="main-container">
        {showProjectInfoSkeleton ? (
          <ProjectInfoSkeleton
            isMultiPoolPrefetched={isMultiPoolPrefetched}
            isHaveSale={isHaveSale}
          />
        ) : (
          <ProjectInfo project={project} />
        )}

        {showPoolsSkeleton && (
          <ul className="grid grid-cols-[repeat(auto-fill,minmax(min(300px,100%),1fr))] gap-6 xl:gap-y-16 mt-16">
            {prefetchedProject?.salePool.map((pool) => (
              <li key={pool.id} className="skeleton-block h-[485px]" />
            ))}
          </ul>
        )}
        {showPools && (
          <ul className="grid grid-cols-[repeat(auto-fill,minmax(min(300px,100%),1fr))] gap-6 xl:gap-y-16 mt-16">
            {project.salePool.map((pool) => (
              <li key={pool.id}>
                <PoolCard
                  projectSlug={project.attributes.slug}
                  pool={pool}
                  token={project.attributes.ticker}
                  className="h-full"
                />
              </li>
            ))}
          </ul>
        )}
      </section>

      {content && <ProjectContent className="mt-16" content={content} />}
    </main>
  );
};

export default Page;
